import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'

import { fromUaRouteSelector } from 'reduxModules/selectors/RouteSelectors'
import { connectionPricesSelector } from 'reduxModules/selectors/PriceSelectors'
import { routeCitiesSelector } from 'reduxModules/selectors/CitySelectors'

import { PricesBase } from './Prices'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  fromUaRoute: fromUaRouteSelector,
  connectionPrices: connectionPricesSelector,
  routeCities: routeCitiesSelector,
})

const enhance = compose(
  connect(mapStateToProps),
  withStyles(styles)
)

export const Prices = enhance(PricesBase)



// WEBPACK FOOTER //
// ./src/components/Prices/index.js